export default "__VITE_ASSET__DZvuLsOQ__ 640w, __VITE_ASSET__Bq62Gq3q__ 1024w, __VITE_ASSET__geRzbItP__ 1920w";